import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=1ef0b2d3"
import script from "./menu.vue?vue&type=script&lang=ts&setup=true"
export * from "./menu.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports